<section class="app-pil-til">
  <div class="app-pil-til__cont d-block d-md-none">
    <div class="app-pil-til__cont__swi">
      <ul class="list-unstyled app-pil-til__cont__ul d-block d-md-none">
        <swiper-container [config]="swiperConfig" class="app-pil-til__cont__swi__sli" wwwSwiper init="false">
          @for (t of tiles(); track $index) {
            <swiper-slide [ngClass]="{ 'app-pil-til__cont__til': true }" swiperSlide role="button">
              <img class="app-pil-til__cont__til__img" [src]="t.img" [alt]="t.title" />
              <h2 class="app-pil-til__cont__til__tit">{{ t.title }}</h2>
              <p class="app-pil-til__cont__til__des" appMobTxtExpander [text]="t.desc"></p>
            </swiper-slide>
          }
        </swiper-container>
      </ul>

      <div class="app-pil-til__cont__swi__nav">
        <div class="app-pil-til__cont__swi__nav--prev"></div>
        <div class="app-pil-til__cont__swi__nav--pag"></div>
        <div class="app-pil-til__cont__swi__nav--next"></div>
      </div>
    </div>
  </div>

  <div class="app-pil-til__cont d-none d-md-flex">
    @for (t of tiles(); track $index) {
      <div class="app-pil-til__cont__til">
        <img class="app-pil-til__cont__til__img" [src]="t.img" [alt]="t.title" />
        <h2 class="app-pil-til__cont__til__tit">{{ t.title }}</h2>
        <p class="app-pil-til__cont__til__des" [innerHtml]="t.desc"></p>
      </div>
    }
  </div>
</section>
